import { render, staticRenderFns } from "./Roleta.vue?vue&type=template&id=0ddc3572&scoped=true&lang=pug&"
import script from "./Roleta.vue?vue&type=script&lang=js&"
export * from "./Roleta.vue?vue&type=script&lang=js&"
import style0 from "./Roleta.vue?vue&type=style&index=0&id=0ddc3572&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddc3572",
  null
  
)

export default component.exports